import { getSupplierProfileOptions } from '../../../api'
import { getItemsFromIdwellApiResponse } from '../../../utils/api'
import { toUserSelectItemsFromOption, UserSelect } from '../../User'

function BuildingSupplierSelect({
  getData = getSupplierProfileOptions,
  getDataItems = getItemsFromIdwellApiResponse,
  toPreparedItems = toUserSelectItemsFromOption,
  ...restProps
}) {
  return (
    <UserSelect
      {...restProps}
      getData={getData}
      getDataItems={getDataItems}
      toPreparedItems={toPreparedItems}
    />
  )
}

export default BuildingSupplierSelect
